import { HttpStatus } from '@bioliberty/http';
import { ExportDownload } from '@bioliberty/lifemind';
import { downloadFromUrl } from '../util';

export const downloadExportResponse = async (response: Response): Promise<void> => {
  if (response.status !== HttpStatus.Ok) {
    return;
  }

  const { url } = (await response.json()) as ExportDownload;
  downloadFromUrl(url);
};
